import React from "react";
import {
  Button,
  Form,
  TextInput,
  Row,
  Column,
  SelectItem,
} from "carbon-components-react";

import ArrowRight24 from "@carbon/icons-react/es/arrow--right/24";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNavigate } from "react-router-dom";
import Select from "carbon-components-react/lib/components/Select/Select";
import useGet from "../../hooks/useGet";
import { userSchema } from "../../services/SchemaService";
import Card from "../../components/Card/Card";
import UserForm from "./UserForm";

const CreateUserPage = () => {
  const { data: roles } = useGet("/lookup/user-roles");
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(userSchema) });

  const navigate = useNavigate();

  const onSubmit = async (data) => {
    try {
      // await http.post("/users", data);
      // toast.success("Conta criada com sucesso");
      // navigate("/admin/utilizadores");
    } catch (error) {
      toast.error(error.response?.data.message);
    }
  };

  return (
    <Card title="Registar Utilizador">
      <UserForm
        mode={"CREATE"}
        url={"/users"}
        successMessage={"Conta criada com sucesso"}
        onSuccessNavigateTo={"../utilizadores"}
      />
    </Card>
  );
};

export default CreateUserPage;
